/* @flow weak */
import UnreadStore from 'stores/UnreadStore';
import AuthActions from 'auth/AuthActions';

/**
 * The object for inter-process communication within Electron.
 *
 * `window.require` is defined by Electron when nodeIntegration: true
 * @see https://github.com/atom/electron/blob/master/docs/api/browser-window.md
 * @return {IPC} https://github.com/atom/electron/blob/master/docs/api/ipc-renderer.md
 */
function getIpc() {
  if (isAvailable()) {
    return window.require('electron').ipcRenderer;
  } else {
    throw new Error('Electron not available');
  }
}

/**
 * Receive each IPC message that the Electron desktop app sends.
 *
 * NOTE: NEVER REMOVE A BINDING DEFINED HERE. That would break installed
 * versions of the desktop app and unlike web we can't auto-update. Instead,
 * if a function can no longer be implemented, notify the user with an alert.
 */
function bindReceivers(ipc, router) {
  ipc.on('show-classes', () => {
    router.push('/classes');
  });

  ipc.on('show-chat', () => {
    router.push('/inbox');
  });

  ipc.on('show-settings', () => {
    router.push('/settings');
  });

  ipc.on('new-conversation', () => {
    router.push('/classes/r/messages/new');
  });

  ipc.on('log-out', () => {
    AuthActions.signOut();
  });
}

function bindSenders(ipc) {
  UnreadStore.addChangeListener(() =>
    ipc.send('set-app-unread-count', UnreadStore.getTotalUnread())
  );
}

function bindIfAvailable(router) {
  if (isAvailable()) {
    const ipc = getIpc();
    bindReceivers(ipc, router);
    bindSenders(ipc);
  }
}

function isAvailable(): boolean {
  return !!(
    (typeof window !== 'undefined') &&
    window.require &&
    window.require.extensions && // test for Node's require, not just any window.require
    window.require('electron') // b/c some malware defines window.require that throws here
  );
}

function showCurrentWindow() {
  window.require('electron').remote.getCurrentWindow().show();
}

export default {
  bindIfAvailable,
  bindReceivers,
  bindSenders,
  isAvailable,
  showCurrentWindow,
};



// WEBPACK FOOTER //
// ./src/lib/Electron.js